import React from 'react';
import { EField } from './EditableField';

export default function SectionSocialProof({ stats = [], mode = 'view', onChange }) {
  const update = (i, key, val) => {
    const next = stats.map((s, idx) => idx === i ? { ...s, [key]: val } : s);
    onChange?.({ stats: next });
  };
  const addStat = () => onChange?.({ stats: [...stats, { number: '0', label: 'Label' }] });
  const removeStat = (i) => onChange?.({ stats: stats.filter((_, idx) => idx !== i) });

  return (
    <section className="bg-ee-bg border-y border-ee-border py-12">
      <div className="ee-container">
        <div className="grid grid-cols-3 gap-6 md:gap-12">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-3xl md:text-5xl font-serif text-gold mb-2">
                <EField value={s.number} onChange={(v) => update(i, 'number', v)} mode={mode} className="text-center" />
              </div>
              <div className="text-xs md:text-sm uppercase tracking-widest text-ee-muted">
                <EField value={s.label} onChange={(v) => update(i, 'label', v)} mode={mode} className="text-center" />
              </div>
              {mode === 'edit' && (
                <button onClick={() => removeStat(i)} className="mt-2 text-xs text-red-400 hover:text-red-300">Remove</button>
              )}
            </div>
          ))}
        </div>
        {mode === 'edit' && (
          <div className="text-center mt-6">
            <button onClick={addStat} className="text-xs px-3 py-1.5 rounded border border-gold/40 text-gold hover:bg-gold/10">+ Add Stat</button>
          </div>
        )}
      </div>
    </section>
  );
}
